export default __webpack_public_path__ + "static/media/skeleton-empty-img-sm.54adce50.svg";